import React, { createContext } from 'react';
import PropTypes from 'prop-types';

import { usePaging } from '../../hooks/use-paging';
import { ChildrenPropType } from '../../prop-types/children';

export const PagingContext = createContext();

export const PagingContextProvider = ({ page: pageProp, pageSize: pageSizeProp, children }) => {
  const paging = usePaging(pageProp, pageSizeProp);

  return <PagingContext.Provider value={paging}>{children}</PagingContext.Provider>;
};

PagingContextProvider.propTypes = {
  page: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  children: ChildrenPropType.isRequired,
};
